var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000391332 7.45312C0.000548997 7.30549 0.0531203 7.16379 0.148177 7.05619L6.68151 0.167673C6.72784 0.114132 6.78474 0.0716253 6.8474 0.0423917C6.91005 0.0131581 6.97767 -0.00195343 7.04609 -0.00195343C7.11451 -0.00195343 7.18214 0.0131581 7.24479 0.0423917C7.30745 0.0716253 7.36344 0.114132 7.40977 0.167673L13.8966 7.05619C13.9941 7.16035 14.0488 7.30133 14.0488 7.44827C14.0488 7.59521 13.9941 7.73619 13.8966 7.84035C13.7975 7.94165 13.6649 7.9981 13.5275 7.9981C13.39 7.9981 13.2583 7.94165 13.1592 7.84035L7.04609 1.33906L0.932942 7.84035C0.833846 7.94165 0.701254 7.9981 0.563801 7.9981C0.426349 7.9981 0.29467 7.94165 0.195573 7.84035C0.0854441 7.74329 0.0151888 7.60432 -0.000391332 7.45312Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.96da61a6242479b3db59052187ad124c.svg";
export { ForwardRef as ReactComponent };